module.exports = __webpack_public_path__ + "img/share.bc799388.png";